import React from "react";

export class CashLiga extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            turnirPobjednici: null,
            brojZapisa: 20
        };

        this.fetchTurnirRezultatiData = this.fetchTurnirRezultatiData.bind(this);
        this.setTurnirPobjediniciData = this.setTurnirPobjediniciData.bind(this);
        this.renderRow = this.renderRow.bind(this);
        this.ucitajJos = this.ucitajJos.bind(this);

        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Cash Liga', 'poker', this.props.user);
    }

    componentDidMount() {
        this.fetchTurnirRezultatiData();
    }

    componentWillUnmount() {
        if (this.dataPromises && this.dataPromises.cancel) {
            this.dataPromises.cancel();
        }

        if (this.props.showLoadingFn) {
            this.props.showLoadingFn(false);
        }
    }

    fetchTurnirRezultatiData() {
        if (this.props.showLoadingFn) {
            this.props.showLoadingFn(true);
        }

        const promises = Promise.all([
            casino.repos.pokerCashLigaRepo.list()
        ]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setTurnirPobjediniciData, function () { });
    }

    setTurnirPobjediniciData(data) {
        const [pobjedinici] = data;

        this.setState({
            turnirPobjednici: pobjedinici || [],
            brojZapisa: 20
        });

        if (this.props.showLoadingFn) {
            this.props.showLoadingFn(false);
        }
    }

    ucitajJos() {
        this.setState((prevState) => ({
            brojZapisa: prevState.brojZapisa + 10
        }));
    }

    renderRow(igrac, i) {
        return (
            <tr key={`${igrac.alias}-${i}`} className="horizontal-lines">
                <td className="text text-8">{igrac.plasman}.</td>
                <td className="text text-1">{igrac.alias}</td>
                <td className="text text-1 text-right text-bold">{igrac.bodovi}</td>
            </tr>
        );
    }

    render() {
        const rezultati = this.state.turnirPobjednici || [];
        const prikazaniRezultati = rezultati.slice(0, this.state.brojZapisa);
        const imaJos = rezultati.length > this.state.brojZapisa;

        return (
            <div>
                <h2 className="v3 padding-sides-medium-2">Rezultati</h2>

                <div className="padding-sides-medium-2">
                    <table className="table-1 v2">
                        <thead>
                            <tr className="text-left text text-6">
                                <th>Plasman</th>
                                <th>Alias</th>
                                <th className="text-right">Bodova</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!this.state.turnirPobjednici && (
                                <tr className="horizontal-lines">
                                    <td colSpan="3">
                                        <span className="text text-1">Dohvaćanje rezultata...</span>
                                    </td>
                                </tr>
                            )}

                            {this.state.turnirPobjednici && !rezultati.length && (
                                <tr className="horizontal-lines">
                                    <td colSpan="3">
                                        <span className="text text-1">Trenutno nema rezultata...</span>
                                    </td>
                                </tr>
                            )}

                            {prikazaniRezultati.map(this.renderRow)}
                        </tbody>
                    </table>

                    {imaJos && (
                        <div className="text-center">
                            <button
                                className="btn medium fill gray blue margin-top-small no-text-transform"
                                onClick={this.ucitajJos}
                            >
                                <span className="icon ico-chevron-down"></span>&nbsp;
                                <span>Prikaži više</span>
                            </button>
                        </div>
                    )}
                </div>

                <div>
                    <h3 className="poker-sub-title">✈️ GLAVNA NAGRADA</h3>
                    <div className="padding-sides-medium-2">
                        <h2 className="v3">Osvoji Live Poker Paket (3.000 €+):</h2>
                        <p>🥇 5 noći u hotelu Crowne Plaza Bratislava</p>
                        <p>🥇 1.000 € buy-in</p>
                        <p>🥇 1.000 € za put i džeparac</p>
                    </div>

                    <br />

                    <div className="padding-sides-medium-2">
                        <h2 className="v3">🎁 NAGRADE</h2>
                        <div>
                            <p>🥇 1.–2. mjesto – Live paket Bratislava</p>
                            <p>👉 3.–5. mjesto – 759 € za turnirske ulaznice</p>
                            <p>👉 6.–10. mjesto – 330 € za turnirske ulaznice</p>
                        </div>
                        <p>Jesi li spreman za novi SuperPoker izazov?</p>
                    </div>
                </div>

                <p style={{ fontStyle: "italic" }}>*rezultati se osvježavaju svakih 5 minuta</p>
            </div>
        );
    }
}